export default {"src":"/_next/static/media/adu.ca107157.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};